import { Component, HostListener, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Ccenter, CcfacRange, OrgCcenter } from '../models';
import { OrgCodeFilter } from '../filters/org-code-filter';
import { GridApi, GridOptions } from 'ag-grid-community';
import { GridCriteria } from '../models/grid-criteria';
import { CcenterFacultyExportService } from '../services';
import { noCaseStringComparer } from 'src/app/shared/no-case-string-comparer';

@Component({
    selector: 'app-cctr-faculty-list',
    templateUrl: './ccf-alpha.component.html',
})
export class CcfAlphaComponent implements OnInit {

    orgCcenters: OrgCcenter[] = [];
    ccenters: Ccenter[];
    ccfacRanges: CcfacRange[];

    rows = [];
    filterdRows = [];
    private gridApi: GridApi;
    ccenterSub: Subscription;
    routeDataSub: Subscription;
    range: string = null;
    gridOptions: GridOptions;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly ccenterFacultyExportService: CcenterFacultyExportService
    ) { }

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.range = params.get('range');
        });

        this.updateCcenter();

        this.gridOptions = <GridOptions>{
            popupParent: document.querySelector("body"),
            columnDefs: [
                {
                    headerName: "Org Unit",
                    field: "orgElementCode",
                    filter: 'orgCodeFilter',
                },
                {
                    headerName: "Org Unit Desciption",
                    field: "orgDescription",
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        filterOptions: ['startsWith', 'contains'],
                        suppressAndOrCondition: true
                    },
                    comparator: noCaseStringComparer
                },
                {
                    headerName: "Cost Center",
                    field: "ccenterElementCode",
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        filterOptions: ['startsWith', 'contains'],
                        suppressAndOrCondition: true
                    }
                },
                {
                    headerName: "Cost Center Description",
                    field: "ccenterDescription",
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        filterOptions: ['startsWith', 'contains'],
                        suppressAndOrCondition: true
                    },
                    comparator: noCaseStringComparer
                }
            ],
            defaultColDef: {
                sortable: true,
                unSortIcon: true
            },
            frameworkComponents: {
                orgCodeFilter: OrgCodeFilter,
            },
            animateRows: true,
            suppressMenuHide: true
        }
    }

    updateCcenter() {
        this.route.data.subscribe(({ ccenters, ccfacRanges }: { ccenters: Ccenter[], ccfacRanges: CcfacRange[] }) => {
            this.ccenters = ccenters;
            this.ccfacRanges = ccfacRanges;
        });

        for (const ccenter of this.ccenters) {
            const ccenterElementCode = Number(ccenter.ccenterElementCode);
            const matchingRange = this.ccfacRanges.find(range => ccenterElementCode >= range.rangeFrom && ccenterElementCode <= range.rangeTo);
            
            if (matchingRange) {
                const orgCcenter = new OrgCcenter({
                    orgElementCode: matchingRange.orgElementCode,
                    orgDescription: matchingRange.description,
                    ccenterElementCode: ccenter.ccenterElementCode,
                    ccenterDescription: ccenter.ccenterDescription,
                });
                this.orgCcenters.push(orgCcenter); 
            }
        }
    }

    exportToExcel() {
        var rows = [];
        this.gridApi.forEachNodeAfterFilter(node => {
            rows.push(node.data)
        })
        var criteria = this.gridApi.getFilterModel();
        var orgUnitFilter = criteria.orgElementCode ? criteria.orgElementCode.value : [] as CcfacRange[];
        var deptFilter = new GridCriteria(criteria.ccenterElementCode);
        var descriptionFilter = new GridCriteria(criteria.ccenterDescription);
        this.ccenterFacultyExportService.exportToExcel(rows, orgUnitFilter, deptFilter, descriptionFilter);
    }

    onGridReady($event) {
        this.gridApi = $event.api as GridApi;
        this.gridApi.setRowData(this.orgCcenters);
        this.gridApi.sizeColumnsToFit();
    }
}